
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandL as ObiOwnShipNoCommandLElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-l.js';
 
 
 

 
 export const ObiOwnShipNoCommandL = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-l',
   elementClass: ObiOwnShipNoCommandLElement,
   events: {
     
   }
  });
 
 